import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMyGoals, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { MY_GOALS_GET, MY_GOALS_UPDATE } from '../new';

import { useEffectOnSuccess } from '.';

const useUserGoals = () => {
  const dispatch = useDispatch();
  const myGoals = useSelector(state => state.userTrainingInfo.myGoals);

  useEffect(() => {
    if (myGoals.status === StateStatus.NOT_INITIALIZED) {
      dispatch(getMyGoals());
    }
  }, [dispatch, myGoals.status]);

  useEffectOnSuccess([state => state.userTrainingInfo.updateMyGoals, state => state.userTrainingInfo.deleteMyGoal], () => {
    dispatch(resetState(MY_GOALS_GET));
    dispatch(resetState(MY_GOALS_UPDATE));
  });

  return myGoals;
};

export default useUserGoals;
